import { PDFDocument } from "pdf-lib";

export function getFileExtension(filePath) {
    const lastDotIndex = filePath.lastIndexOf('.');
    if (lastDotIndex === -1) {
        return '';
    }

    return filePath.substring(lastDotIndex + 1);
}

export function debugBase64(base64URL) {
    const win = window.open();
    win?.document.write('<iframe src="' + base64URL + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
}

export function debugBase64Pdf(base64URL) {
    const win = window.open();
    const pdfDataURL = 'data:application/pdf;base64,' + base64URL;
    win?.document.write(`
        <html>
        <head>
            <title>PDF Viewer</title>
        </head>
        <body>
            <iframe src="${pdfDataURL}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>
        </body>
        </html>
    `);

    win?.document?.close();
}

export function debugBase64Img(base64, mimeType = 'image/jpeg') {
    const win = window.open('', '_blank');
    if (!win) {
        console.error('Popup blocked.');
        return;
    }
    const dataUrl = `data:${mimeType};base64,${base64}`;
    const html = `
    <!DOCTYPE html>
    <html>
        <head>
        <title>Image Preview</title>
        <style>
            body {
            margin: 0;
            background: #000;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
            }
            img {
            max-width: 100%;
            max-height: 100%;
            }
        </style>
        </head>
        <body>
        <img src="${dataUrl}" alt="Preview Image" />
        </body>
    </html>
    `;
    win.document.write(html);
    win.document.close();
}

export function debugBase64PdfBlob(base64URL) {
    // Ensure base64URL starts with 'data:application/pdf;base64,' (just in case)
    const base64Data = base64URL.startsWith('data:application/pdf;base64,')
        ? base64URL.split(',')[1]  // Extract the base64 data part
        : base64URL;

    // Create a Blob from the base64 data
    const byteCharacters = atob(base64Data);  // Decode base64 to binary
    const byteArrays = [];

    // Convert the binary data to a byte array
    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
    }

    // Create a Blob from the byte arrays
    const blob = new Blob(byteArrays, { type: 'application/pdf' });

    // Create an object URL for the Blob
    const pdfBlobURL = URL.createObjectURL(blob);

    // Open a new window
    const win = window.open();
    if (!win) {
        console.error('Pop-up blocked or window failed to open');
        return;
    }

    // Write PDF viewer content into the new window
    win.document.write(`
      <html>
      <head>
          <title>PDF Viewer</title>
      </head>
      <body>
          <iframe src="${pdfBlobURL}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>
      </body>
      </html>
  `);

    // Explicitly close the document to trigger rendering
    win.document.close();
}

export function getImageDataUrlFromBase64(base64, mimeType = 'image/jpeg') {
    if (!base64 || typeof base64 !== 'string') {
        throw new Error('Invalid base64 input');
    }
    
    // Ensure mimeType starts with "image/"
    if (!mimeType.startsWith('image/')) {
        mimeType = `image/${mimeType}`;
    }
    
    return `data:${mimeType};base64,${base64}`;
}

export function createPdfBlobUrlFromBase64(base64URL) {
    // Ensure base64URL starts with 'data:application/pdf;base64,' (just in case)
    const base64Data = base64URL.startsWith('data:application/pdf;base64,')
        ? base64URL.split(',')[1]  // Extract the base64 data part
        : base64URL;

    // Create a Blob from the base64 data
    const byteCharacters = atob(base64Data);  // Decode base64 to binary
    const byteArrays = [];

    // Convert the binary data to a byte array
    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
    }

    // Create a Blob from the byte arrays
    const blob = new Blob(byteArrays, { type: 'application/pdf' });

    // Create an object URL for the Blob
    const pdfBlobURL = URL.createObjectURL(blob);

    return pdfBlobURL;
}

export function getSubmitionMode(arr = []) {
    if (arr.includes("manually") && arr.includes("ezsub")) {
        return "Mixture";
    } else if (arr.includes("manually")) {
        return "Manual";
    } else if (arr.includes("ezsub")) {
        return "eSubmission";
    }
    return "";
}

export function mobileNumberRectify(mobileNumber: string) {
    let cleanNumber = mobileNumber.replace(/[^0-9+]/g, "")
    if (cleanNumber[0] !== "+") {
        cleanNumber = `+${cleanNumber}`
    }
    cleanNumber = cleanNumber.replace(/\++/g, "+")
    return cleanNumber
}
export function formatMobileNumber(countryCode: string, mobile: string): string {
    if (!countryCode || !mobile) return '';
    const regex = /\d+/
    const f = countryCode.match(regex);
    const formattedMobile = mobile.trim();
    if (f) {
        return `+${f[0]}${formattedMobile}`;
    }
    let mob = countryCode + formattedMobile
    mob = mobileNumberRectify(mob)
    return mob
}



export function PDFbase64ToBlob(base64String: string): Blob {
    const byteCharacters = atob(base64String);

    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: 'application/pdf' });

    return blob
}

export function PDFbase64ToFile(base64String: string, filename: string = "document.pdf"): File {
    if (base64String?.length === 0) return
    const blob = PDFbase64ToBlob(base64String)
    const file = new File([blob], filename, { type: blob?.type || 'application/pdf' })
    return file
}


export async function getPDFPageNumber(pdf: File) {
    let total = 0
    if (!pdf) return total;


    try {
        const existingPdfBytes = await pdf.arrayBuffer()
        const pdfDoc = await PDFDocument.load(existingPdfBytes)
        const pages = pdfDoc.getPages()
        total = pages?.length || 0
    } catch (error) {
        console.log("Error: ", error);
    }
    return total
}

export function scrollToKycFormTop(subject) {
    if (subject && subject[0] && subject[0] === 'kycForm') {
        const container = document.getElementById('efna-container');
        if (container) {
            const scrollContainer = container.querySelector('div');
            if (scrollContainer) {
                scrollContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }
}


export function containsOnlyDigits(str = '') {
    let value = str
    if (typeof value !== 'string') {
        value = `${value}`
    }
    // Remove all whitespace from the string
    const cleanedStr = value.replace(/\s+/g, '');
    // Check if the cleaned string contains only digits
    return /^\d+$/.test(cleanedStr);
}

export function isFilterEmpty(filter = {}) {
  // Recursively checks if all arrays are empty
  function isObjectEmpty(obj) {
    return Object.values(obj).every((value) => {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else if (typeof value === "object" && value !== null) {
        return isObjectEmpty(value);
      } else {
        // Non-array and non-object types considered invalid in this filter
        return true;
      }
    });
  }
  return isObjectEmpty(filter);
}
